// 按钮权限指令封装
import { userStore } from '@/store/user';

const isAuthDirective = {
  mounted(el, binding) {
    const btnCodes = binding.value;
    const isAuth = hasPermission(btnCodes);
    if (!isAuth) {
      el.parentNode?.removeChild(el);
    }
  },
};

const hasPermission = btnPermissions => {
  // 用户的权限码
  const store = userStore();
  const userPermission = store.btnPower;
  // 按钮所需单个权限code
  if (!Array.isArray(btnPermissions)) {
    return userPermission.indexOf(btnPermissions) !== -1;
  }
  // 按钮所需多个权限code
  for (const btnPermissionCode of btnPermissions) {
    if (!userPermission?.includes(btnPermissionCode)) {
      return false;
    }
  }
  return true;
};

// 默认导出一个isAuthDirective方法
export default {
  install(app) {
    app.directive('isAuth', isAuthDirective);
  },
};
